import {Directive} from '@angular/core';

import {WizardStepForm} from '../../sdk/interface/form/wizard-step-form';

/**
 * Base class for the KYC verification wizard's step forms. The shared pre-fill, read-only and
 * guest-admin exemption lives in {@link WizardStepForm}.
 */
@Directive()
export abstract class KycWizardStepForm<T> extends WizardStepForm<T>
{
}
